import { Device } from '@@partner:types:app'
import type {
  CommonSort,
  NestedFilter,
  CommonPager,
  PageInfo
} from '@@partner:types:graphql'

import { gql, useQuery } from '@apollo/client'

import { SHORTCUT_PAGE_INFO_FIELDS } from '@@partner:graphql/shortcuts'

export interface AllShopDevicesQuery {
  allShopDevices: {
    edges: Device[]
    pageInfo: PageInfo
  }
}

export interface AllShopDevicesVariables {
  filter?: NestedFilter
  sort?: CommonSort
  pager?: CommonPager
}

export const GQL_QUERY_ALL_SHOP_DEVICES = gql`
  query allShopDevices(
    $filter: NestedFilterInput
    $pager: CommonPagerInput
    $sort: CommonSortInput
  ) {
    allShopDevices(
      filter: $filter
      sort: $sort
      pager: $pager
    ) {
      edges {
        id
        device_hardware_id
        device_name
        device_type
        device_model
        device_os
        device_os_version
        device_app_version
        shop_id
        shop {
          id
          name
          phone
          address
        }
      }
      pageInfo {
        ${SHORTCUT_PAGE_INFO_FIELDS}
      }
    }
  }
`

export const useFetchAllShopDevices = (variables: AllShopDevicesVariables) =>
  useQuery<AllShopDevicesQuery, AllShopDevicesVariables>(
    GQL_QUERY_ALL_SHOP_DEVICES,
    { variables, fetchPolicy: 'cache-and-network' }
  )